export const UPDATE_GENERATIVE_FAQ_STATE = "UPDATE_GENERATIVE_FAQ_STATE"
export const MORE_GENERATIVE_FAQS_LOADED = "MORE_GENERATIVE_FAQS_LOADED"
export const FAQ_CREATED = "FAQ_CREATED"
export const FAQ_DELETED = "FAQ_DELETED"
export const FAQ_UPDATED = "FAQ_UPDATED"
